import { Controller } from "@hotwired/stimulus"

// Disables a question form's Submit until the answer is complete: text written
// (open), every cell filled (table), or a choice selected (quiz/poll). The
// compact tooltip wrapping the submit only shows while it is disabled (see
// data-tippy-only-disabled in tippy_controller).
export default class extends Controller {
  static targets = ["submit"]

  static events = ["input", "change", "trix-change", "trix-initialize"]

  connect() {
    this.update = this.update.bind(this)
    this.constructor.events.forEach((event) => this.element.addEventListener(event, this.update))
    this.update()
  }

  disconnect() {
    this.constructor.events.forEach((event) => this.element.removeEventListener(event, this.update))
  }

  update() {
    if (!this.hasSubmitTarget) return

    if (this.complete()) {
      this.submitTarget.disabled = false
      this.submitTarget.removeAttribute("aria-disabled")
    } else {
      this.submitTarget.disabled = true
      this.submitTarget.setAttribute("aria-disabled", "true")
    }
  }

  complete() {
    const trix = this.element.querySelector("trix-editor")
    if (trix) return this.trixText(trix).trim().length > 0

    const cells = this.element.querySelectorAll("[data-table-cell-input]")
    if (cells.length) return Array.from(cells).every((cell) => cell.value.trim().length > 0)

    const radios = this.element.querySelectorAll("input[type=radio]")
    return Array.from(radios).some((radio) => radio.checked)
  }

  trixText(trix) {
    return trix.editor ? trix.editor.getDocument().toString() : trix.innerText
  }
}
